import api from "../../../services/api";
import { DataBoletoRaw } from "../types";

export async function getBillDetailInfo(barcode: string) {
  const response = await api.get<DataBoletoRaw>(`/backoffice/bill/search/${barcode}/raw`)

  return response.data
}